@if ($output().src) {
    <ng2-pdfjs-viewer
        [pdfSrc]="$output().src!"
    ></ng2-pdfjs-viewer>
}